import axios from 'axios';
import config from '@/vue-caas/config/config.js';
// import idb from '@/vue-dlb/utils/idb';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.setupApiUrl;

const communicationStoreModule = {
  // namespaced: false,

  state: {
    communicationList: [],
    communicationSelectBoxList: [],
    validCommunicationList: [],
    communication: {},
    communicationId: '',
    dataSet01Source: [],
    filter: {},
    communicationChange: {},
  },
  mutations: {
    SET_STORE_COMMUNICATION_LIST(state, communicationList) {
      if (
        JSON.stringify(state.dataSet01Source) !== JSON.stringify(communicationList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('COM');
      }
      state.communicationList = communicationList;
      state.dataSet01Source = communicationList;
    },
    SET_STORE_COMMUNICATION_SELECT_BOX_LIST(state, communicationSelectBoxList) {
      state.communicationChange = compareTableData(
        state.communicationSelectBoxList,
        communicationSelectBoxList,
        'id'
      );
      state.communicationSelectBoxList = communicationSelectBoxList.map((item) => {
        return {
          ...item,
          text: `${item.name} (${item.type})`,
          value: item.id,
        };
      });
    },
    SET_STORE_COMMUNICATION(state, communication) {
      state.communication = communication;
    },
    SET_STORE_COMMUNICATION_ID(state, id) {
      state.communicationId = id;
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('COM');
      }
    },
    SET_STORE_VALID_COMMUNICATION_LIST(state, communicationList) {
      state.validCommunicationList = communicationList;
    },
    SET_STORE_COMMUNICATION_FILTER(state, filter) {
      let datarows = state.dataSet01Source;
      state.filter = filter;
      let filterBy = state.filter;
      let listResult = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.communicationList = listResult;
      // state.filter = filter;
    },
  },
  actions: {
    getCommunicationList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/list', params)
        .then((response) => {
          let data = response.data;
          data = data.filter((e) => !e.commParentNo);
          commit('SET_STORE_COMMUNICATION_LIST', data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    // 2021.10.26 203728 SPKA-224 return data not save store
    getCommunicationSelectBoxList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/list/forsetup', params)
        .then((response) => {
          let data = response.data;
          data = data.filter((e) => !e.commParentNo);
          commit('SET_STORE_COMMUNICATION_SELECT_BOX_LIST', data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    getCommunication: async ({ commit }, params) => {
      // commit('SET_STORE_COMMUNICATION', params);
      await axios
        .post(baseURI + '/comm/detail', { comId: params })
        .then((response) => {
          commit('SET_STORE_COMMUNICATION', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    insertComm: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/insert', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_COMMUNICATION_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    insertCommFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/insert', params)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_COMMUNICATION_ID', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    editComm: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/update', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_COMMUNICATION_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    editCommFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/update', params)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_COMMUNICATION_ID', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    deleteComm: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/comm/delete', params)
        .then((response) => {
          // alert(response.data);
          // commit('SET_STORE_COMMUNICATION_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },

    checkComm: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/comm/check/${params.name}`)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_VALID_COMMUNICATION_LIST', response.data);
        })
        .catch((ex) => {
          // alert(ex);
          throw ex;
        });
    },
    setFilterCommunication: async ({ commit }, filter) => {
      commit('SET_STORE_COMMUNICATION_FILTER', filter);
    },
  },
  getters: {
    communicationList: (state) => state.communicationList,
    communicationSelectBoxList: (state) => state.communicationSelectBoxList,
    communication: (state) => state.communication,
    communicationId: (state) => state.communicationId,
    validCommunicationList: (state) => state.validCommunicationList,
    filter: (state) => state.filter,
    communicationChange: (state) => state.communicationChange,
  },
};

export default communicationStoreModule;
